// Services
export const BOOKING_API_URL = process.env.REACT_APP_BOOKING_API_URL;
export const CRM_API_URL = process.env.REACT_APP_CRM_API_URL;

export const ENDPOINTS = {
  booking: {
    transfer: `${BOOKING_API_URL}/api/transfers`,
  },
  CRM: {
    statement: `${CRM_API_URL}/app/pwa/statements`,
    event: `${CRM_API_URL}/app/pwa/events`,
    company: `${CRM_API_URL}/app/pwa/companies`,
  },
};
